import axios from "axios";
import config from "@/router/globalConfig";

export default {
  Logout(_data_) {
    return axios.post(config.WEB_API_PATH + "Login/Logout", _data_, {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      }
    });
  },
  GetLicense() {
    return axios.get(config.WEB_API_PATH + "Login/GetLicense", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: null
    });
  },
  SubmitLicense(_data_) {
    return axios.post(config.WEB_API_PATH + "Login/SubmitLicense", _data_, {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      }
    });
  },
  UpdateUserOnline(_data_) {
    return axios.post(config.WEB_API_PATH + "Login/UpdateUserOnline", _data_, {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      }
    });
  },
  GetGenderList(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/GetGenderList", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  getUserType(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/GetUserType", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  getRank(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/GetRank", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  UserActivation(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/UserActivation", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  GenerateCaptcha(_data_) {
    return axios.post(config.WEB_API_PATH + "Login/GenerateCaptcha", "", {
      // headers: { __RequestVerificationToken: config.AF_Token, Authorization: config.LOG_Token },
      params: _data_
    });
  },
  GetCurrentUser(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/GetCurrentUser", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  OTPVerification(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/OTPVerification", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  resetPasswordOnline(_data_) {
    return axios.post(
      config.WEB_API_PATH + "Login/ResetPasswordOnline",
      _data_,
      {
        headers: {
          __RequestVerificationToken: config.AF_Token,
          Authorization: config.LOG_Token
        }
      }
    );
  },
  getForgetUser(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/GetForgetUser", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  generateLoginOTP(_data_) {
    return axios.post(config.WEB_API_PATH + "Login/GenerateLoginOTP", _data_, {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      }
    });
  },
  resendOTP(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/ResendOTP", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  OTPVerification(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/OTPVerification", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  },
  GetUserRights(_data_) {
    return axios.get(config.WEB_API_PATH + "Login/GetUserRights", {
      headers: {
        __RequestVerificationToken: config.AF_Token,
        Authorization: config.LOG_Token
      },
      params: _data_
    });
  }
};



// WEBPACK FOOTER //
// ./src/components/servicesJS/Login.js